import { createFileRoute } from '@tanstack/react-router';
import { EmployeesContainer } from 'src/containers/employees/employees-container';

export const Route = createFileRoute('/_layout/tenant/employees/_layout')({
  component: EmployeesContainer,
});
